/**
 * Dropdown Switcher
 * Vanilla JS dropdown component for language and currency switchers
 */
export function initDropdownSwitchers() {
  // Initialize toggle button for switchers container
  const toggleBtn = document.querySelector("[data-switchers-toggle]");
  const container = document.querySelector("[data-switchers-container]");

  if (toggleBtn && container) {
    toggleBtn.addEventListener("click", () => {
      toggleBtn.classList.add("hidden");
      container.classList.remove("hidden");
      container.classList.add("flex");
    });
  }

  const switchers = document.querySelectorAll("[data-dropdown-switcher]");

  switchers.forEach((switcher) => {
    const button = switcher.querySelector("[data-dropdown-toggle]");
    const dropdown = switcher.querySelector("[data-dropdown-menu]");

    if (!button || !dropdown) return;

    // Skip if already initialized
    if (switcher.dataset.initialized) return;
    switcher.dataset.initialized = "true";

    // Toggle dropdown on button click
    button.addEventListener("click", (e) => {
      e.stopPropagation();
      const isHidden = dropdown.classList.contains("hidden");

      // Close all other dropdowns first
      document.querySelectorAll("[data-dropdown-menu]").forEach((d) => {
        d.classList.add("hidden");
        d.closest("[data-dropdown-switcher]")
          ?.querySelector("svg")
          ?.classList.remove("rotate-180");
      });

      if (isHidden) {
        dropdown.classList.remove("hidden");
        button.querySelector("svg")?.classList.add("rotate-180");
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (!switcher.contains(e.target)) {
        dropdown.classList.add("hidden");
        button.querySelector("svg")?.classList.remove("rotate-180");
      }
    });

    // Close on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        dropdown.classList.add("hidden");
        button.querySelector("svg")?.classList.remove("rotate-180");
      }
    });
  });
}

// Keep old function name for backwards compatibility
export const initLanguageSwitcher = initDropdownSwitchers;
